import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'app/back-office/shared/services/core/utils.service';
import { AuthService } from 'app/shared/auth/auth.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit, OnDestroy {

  timer = 5;
  withoutTimer: boolean;

  private timeout: any;

  constructor(
    private _utils: UtilsService,
    private _auth: AuthService,
  ) {
    this._utils.setNavbarTitle('Error: unauthorized');
  }

  public ngOnInit() {
    this.onTimer();
  }

  public ngOnDestroy(): void {
    clearTimeout(this.timeout);
  }

  public onTimer() {
    this.timeout = setTimeout(() => {
      this.timer -= 1;
      if (!this.timer) this._auth.logout();
      else this.onTimer();
    }, 1000);
  }
}
